import { SignIn } from '@clerk/clerk-react';
import { createFileRoute } from '@tanstack/react-router';
import { gradient } from '../ad/theme';

/**
 * Public route. The `_authenticated` guard redirects unauthenticated users here
 * with a `?redirect=<href>` param; we validate it loosely and forward it to
 * Clerk so the user lands back where they started after signing in.
 *
 * `redirect` is optional, and the key is omitted entirely when absent so the
 * search object satisfies `exactOptionalPropertyTypes` and `<Link to="/sign-in">`
 * callers aren't forced to supply it.
 */
export const Route = createFileRoute('/sign-in')({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();
  // Sit the signed-out screen on the same dark teal-mint page background as the
  // app shell so there is NO flash of a white card on a dark page (K4 gotcha).
  return (
    <main
      className="flex min-h-svh items-center justify-center p-8"
      style={{ background: gradient.pageBg }}
    >
      <SignIn forceRedirectUrl={redirect ?? null} signUpUrl="/sign-up" />
    </main>
  );
}
